import { render, staticRenderFns } from "./dome.vue?vue&type=template&id=076e1766&scoped=true"
import script from "./dome.vue?vue&type=script&lang=js"
export * from "./dome.vue?vue&type=script&lang=js"
import style0 from "./dome.vue?vue&type=style&index=0&id=076e1766&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076e1766",
  null
  
)

export default component.exports